/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default value: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - includeForListingTypes:        An array of listing types, for which the extended
 *   (optional)                     data is relevant and should be added.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Flex CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default value: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'SelectMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default value: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */
import banglesImage from './images/bangles.png';
import bagImage from './images/bag.png';
import dressImage from './images/women.png';
import shoeImage from './images/shoe.png';
import men from './images/men.png';
import kid from './images/kids.png';


// women category

import womenClothing from '../assets/New Images/Women-Clothing.jpg'
import womenShoes from '../assets/New Images/Women-Shoes.jpg'
import womenPurse from '../assets/New Images/Women-Purse.jpg'
import womenJewelry from '../assets/New Images/Women-Jewelry.jpg'
import womenMisc from '../assets/New Images/Women-Misc.jpg'


import menClothing from '../assets/New Images/Men-Clothing.jpg'
import menShoes from '../assets/New Images/Men-Shoes.jpg'
import menTurban from '../assets/New Images/Men-Turban.jpg'

import kidClothing from '../assets/New Images/Kids-Clothing.jpg'
import kidShoes from '../assets/New Images/Kids-Shoes.jpg'









// import womenShoes from '../assets/New Images/Women-Shoes.jpg'
export const W1FIELDS = ['1', '2', '3', '4', '5', '6', '7'];
export const W2FIELDS = ['1', '2', '3', '4', '5', '6'];
export const W3FIELDS = ['1', '2', '3', '4', '5', '6', '7'];
export const W4FIELDS = ['1', '2'];
export const W5FIELDS = ['1', '2'];
export const M1FIELDS = ['1', '2', '3', '4', '5'];
export const M2FIELDS = ['1', '2', '3', '4', '5', '6'];
export const M3FIELDS = ['1', '2', '3'];
export const conditions = [
  {
    label: 'New with tags',
    key: 'newWithTags',
    value: 'newWithTags',
    subheading:
      'Just like in the store. The tags are still attached and/or its packed in the original packaging. Never worn and has no flaws.',
  },
  {
    label: 'New with no tags',
    key: 'newWithNoTags',
    value: 'newWithNoTags',
    subheading:
      'Brand new, but without the tags or original packaging. Never worn and has no flaws.',
  },
  {
    label: 'Like new',
    key: 'likeNew',
    value: 'likeNew',
    subheading: 'Worn 1-2 times, but looks new. Has minimal flaws or imperfections.',
  },
  {
    label: 'Very good',
    key: 'veryGood',
    value: 'veryGood',
    subheading:
      'Worn a few times, but still looks great. It might have a few slight imperfections, which are clearly shown and mentioned in your listing.',
  },
  {
    label: 'Good',
    key: 'good',
    value: 'good',
    subheading:
      'Worn frequently and may have sign of wear, which are clearly shown and mentioned in your listing.',
  },
  {
    label: 'Satisfactory',
    key: 'satisfactory',
    value: 'satisfactory',
    subheading: 'Worn a lot and has flaws, which are clearly shown and mentioned in your listing.',
  },
];
const commonColor = [
  { label: 'Beige', key: 'beige', value: 'beige' },
  { label: 'Black', key: 'black', value: 'black' },
  { label: 'Blue', key: 'blue', value: 'blue' },
  { label: 'Brown', key: 'brown', value: 'brown' },
  { label: 'Green', key: 'green', value: 'green' },
  { label: 'Grey', key: 'grey', value: 'grey' },
  { label: 'Orange', key: 'orange', value: 'orange' },
  { label: 'Pink', key: 'pink', value: 'pink' },
  { label: 'Purple', key: 'purple', value: 'purple' },
  { label: 'Red', key: 'red', value: 'red' },
  { label: 'Tan', key: 'tan', value: 'tan' },
  { label: 'White', key: 'white', value: 'white' },
  { label: 'Yellow', key: 'yellow', value: 'yellow' },
  { label: 'Gold', key: 'gold', value: 'gold' },
  { label: 'Silver', key: 'silver', value: 'silver' },
  { label: 'Multicolour', key: 'multicolored', value: 'multicolored' },
  { label: 'Other', key: 'other', value: 'other' },
];
export const sleevesOptions = [
  {
    label: 'Long',
    key: 'long',
    value: 'long',
    title: 'Long-Sleeve',
  },
  {
    label: 'Mid',
    key: 'mid',
    value: 'mid',
    title: 'Mid-Sleeve',
  },
  {
    label: 'Sleeveless',
    key: 'sleeveless',
    value: 'sleeveless',
    title: 'Sleeveless',
  },
];
export const categoryOptions = [
  {
    label: 'Women',
    key: 'women',
    value: 'women',
    image: womenClothing,
    subCategories: [
      {
        label: 'Clothing',
        key: 'clothing',
        value: 'clothing',
        image: womenClothing,
        type: [
          {
            label: 'Sarees',
            sLabel: 'Saree',
            key: 'sarees',
            value: 'sarees',
            showSleeves: true,
            image: [
              {
                image: 'W3',
                fields: W3FIELDS,
              },
            ],
          },
          {
            label: 'Lehengas',
            sLabel: 'Lehenga',
            key: 'lehengas',
            showSleeves: true,
            value: 'lehengas',
            // image: 'W3,W4',
            image: [
              {
                image: 'W3',
                fields: W3FIELDS,
              },
              {
                image: 'W4',
                fields: W4FIELDS,
              },
            ],
          },
          {
            label: 'Dresses/Gown',
            sLabel: 'Dress/Gown',
            key: 'dresses',
            showSleeves: true,
            value: 'dresses',

            // image: 'W1'
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
            ],
          },
          {
            label: 'Salwar Kameez Suits',
            sLabel: 'Salwar Kameez Suit',
            key: 'salwar-kameez',
            showSleeves: true,
            value: 'salwar-kameez',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Dhoti Salwar Suits',
            sLabel: 'Dhoti Salwar Suit',
            key: 'dhoti-salwar',

            value: 'dhoti-salwar',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Palazzo/Pant Suits',
            sLabel: 'Palazzo/Pant Suit',
            showSleeves: true,
            key: 'palazzo-suit',
            value: 'palazzo-suit',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Churidar/Pajami Suits',
            sLabel: 'Churidar/Pajami Suit',
            key: 'churidar-suit',
            showSleeves: true,
            value: 'churidar-suit',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Anarkali Suits',
            sLabel: 'Anarkali Suit',
            key: 'anarkali-suit',
            showSleeves: true,
            value: 'anarkali-suit',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Shararas',
            sLabel: 'Sharara',
            showSleeves: true,
            key: 'sharara',
            value: 'sharara',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Abaya Suits',
            sLabel: 'Abaya Suit',
            key: 'abaya',
            showSleeves: true,
            value: 'abaya',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Fusion Outfits',
            key: 'fusion',
            sLabel: 'Fusion Outfit',
            showSleeves: true,
            value: 'fusion',
            // image: 'W1,W2',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
              {
                image: 'W3',
                fields: W3FIELDS,
              },
              {
                image: 'W4',
                fields: W4FIELDS,
              },
            ],
          },
          {
            label: 'Kurtis',
            sLabel: 'Kurti',
            showSleeves: true,
            key: 'kurti',
            value: 'kurti',
            //  image: 'W1'
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
            ],
          },
          {
            label: 'Dupattas',
            sLabel: 'Dupatta',
            key: 'dupattas',
            value: 'dupattas',
            //  image: 'W5'
            image: [
              {
                image: 'W5',
                fields: W5FIELDS,
              },
            ],
          },
          {
            label: 'Shawls',
            sLabel: 'Shawl',
            key: 'shawls',
            value: 'shawls',
            // image: 'W5'
            image: [
              {
                image: 'W5',
                fields: W5FIELDS,
              },
            ],
          },
          { label: 'Fabrics', sLabel: 'Fabric', key: 'fabric', value: 'fabric' },
          {
            label: 'Other',
            key: 'other',
            value: 'other',

            // image: 'W1,W2,W3,W4,W5'
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
              {
                image: 'W3',
                fields: W3FIELDS,
              },
              {
                image: 'W4',
                fields: W4FIELDS,
              },
              {
                image: 'W5',
                fields: W5FIELDS,
              },
            ],
          },
        ],
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
        colour: commonColor,
        embroidery: [
          { label: 'Handwork', key: 'handwork', value: 'handwork' },
          { label: 'Mirror', key: 'mirror', value: 'mirror' },
          { label: 'Sequins', key: 'sequins', value: 'sequins' },
          { label: 'Thread', key: 'thread', value: 'thread' },
          { label: 'Print', key: 'print', value: 'print' },
          { label: 'Pearl', key: 'pearl', value: 'pearl' },
          { label: 'Stone', key: 'stone', value: 'stone' },
          { label: 'Zari', key: 'zari', value: 'zari' },
          { label: 'Beadwork', key: 'beadwork', value: 'beadwork' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        fabrics: [
          { label: 'Brocade', key: 'brocade', value: 'brocade' },
          { label: 'Chanderi', key: 'chanderi', value: 'chanderi' },
          { label: 'Chiffon', key: 'chiffon', value: 'chiffon' },
          { label: 'Crepe', key: 'crepe', value: 'crepe' },
          { label: 'Muslin', key: 'muslin', value: 'muslin' },
          { label: 'Organza', key: 'organza', value: 'organza' },
          { label: 'Pure Silk', key: 'pure-silk', value: 'pure-silk' },
          { label: 'Silk', key: 'silk', value: 'silk' },
          { label: 'Velvet', key: 'velvet', value: 'velvet' },
          { label: 'Georgette', key: 'georgette', value: 'georgette' },
          { label: 'Net', key: 'net', value: 'net' },
          { label: 'Satin', key: 'satin', value: 'satin' },
          { label: 'Chinon', key: 'chinon', value: 'chinon' },
          { label: 'Rayon', key: 'rayon', value: 'rayon' },
          { label: 'Cotton', key: 'cotton', value: 'cotton' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
      },
      {
        label: 'Shoes',
        key: 'shoes',
        value: 'shoes',
        image: womenShoes,

        type: [
          { label: 'Jutti', key: 'jutti', value: 'jutti' },
          { label: 'Mojhay', key: 'mojhay', value: 'mojhay' },
          { label: 'Sandals', key: 'sandals', value: 'sandals' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        size: [
          { label: '3', key: '3', value: '3' },
          { label: '3.5', key: '3.5', value: '3.5' },
          { label: '4', key: '4', value: '4' },
          { label: '4.5', key: '4.5', value: '4.5' },
          { label: '5', key: '5', value: '5' },
          { label: '5.5', key: '5.5', value: '5.5' },
          { label: '6', key: '6', value: '6' },
          { label: '6.5', key: '6.5', value: '6.5' },
          { label: '7', key: '7', value: '7' },
          { label: '7.5', key: '7.5', value: '7.5' },
          { label: '8', key: '8', value: '8' },
          { label: '8.5', key: '8.5', value: '8.5' },
          { label: '9', key: '9', value: '9' },
          { label: '9.5', key: '9.5', value: '9.5' },
          { label: '10', key: '10', value: '10' },
          { label: '10.5', key: '10.5', value: '10.5' },
          { label: '11', key: '11', value: '11' },
          { label: '11.5', key: '11.5', value: '11.5' },
          { label: '12', key: '12', value: '12' },
          { label: '12.5', key: '12.5', value: '12.5' },
          { label: '13', key: '13', value: '13' },
          { label: '13.5', key: '13.5', value: '13.5' },
          { label: '14', key: '14', value: '14' },
          { label: '14.5', key: '14.5', value: '14.5' },
          { label: '15', key: '15', value: '15' },
        ],
        colour: commonColor,
      },
      {
        label: 'Purses',
        key: 'purses',
        sLabel: 'Purse',
        value: 'purses',
        image: womenPurse,

        
        
        colour: commonColor,
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
      },

      {
        label: 'Jewelry',
        key: 'jewelry',
        sLabel: 'Jewelry',
        value: 'jewelry',
        image: womenJewelry,
        

        type: [
          { label: 'Tikka', key: 'tikka', value: 'tikka' },
          { label: 'Hand pieces', key: 'hand-pieces', value: 'hand-pieces' },
          { label: 'Bangles', key: 'bangles', value: 'bangles' },
          { label: 'Set', key: 'set', value: 'set' },
          { label: 'Rings', key: 'rings', value: 'rings' },
          { label: 'Earrings', key: 'earrings', value: 'earrings' },
          { label: 'Necklaces', key: 'necklaces', value: 'necklaces' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        colour: [
          { label: 'Gold', key: 'gold', value: 'gold' },
          { label: 'Silver', key: 'silver', value: 'silver' },
          { label: 'Multicolored', key: 'multicolored', value: 'multicolored' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
      },
      {
        label: 'Misc',
        key: 'misc',
        value: 'misc',
        image: womenMisc,
        

        type: [
          { label: 'Bindis', key: 'bindis', value: 'bindis' },
          { label: 'Parandi', key: 'parandi', value: 'parandi' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
      },
    ],
  },

  {
    label: 'Men',
    key: 'men',
    value: 'men',
    image: menClothing,
    subCategories: [
      {
        label: 'Clothing',
        key: 'clothing',
        value: 'clothing',
        image: menClothing,
        type: [
          {
            label: 'Sherwanis',
            sLabel: 'Sherwani',
            key: 'sherwani',
            value: 'sherwani',

            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Achkins',
            sLabel: 'Achkin',
            key: 'achkin',
            value: 'achkin',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Dhoti Kurtas',
            sLabel: 'Dhoti Kurta',
            key: 'dhoti-kurta',
            value: 'dhoti-kurta',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Kurta Pajamas',
            sLabel: 'Kurta Pajama',
            key: 'kurta-pajama',
            value: 'kurta-pajama',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Kurta Pajamas with Vest',
            sLabel: 'Kurta Pajama with Vest',
            key: 'kurta-pajama-2-pc',
            value: 'kurta-pajama-2-pc',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Jacket Suits 3 pc',
            sLabel: 'Jacket Suit 3 pc',
            key: 'jacket-3-pc',
            value: 'jacket-3-pc',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Nehru Suits',
            sLabel: 'Nehru Suit',
            key: 'nehru-jacket',
            value: 'nehru-jacket',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Other',
            key: 'other',
            value: 'other',
            image: [
              {
                image: 'M1',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
        ],

        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
        colour: commonColor,
        embroidery: [
          { label: 'Threadwork', key: 'threadwork', value: 'threadwork' },
          { label: 'Print', key: 'print', value: 'print' },
          { label: 'Stonework', key: 'stonework', value: 'stonework' },
          { label: 'Zari', key: 'zari', value: 'zari' },
          { label: 'Beadwork', key: 'beadwork', value: 'beadwork' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        fabrics: [
          { label: 'Rayon', key: 'rayon', value: 'rayon' },
          { label: 'Silk', key: 'silk', value: 'silk' },
          { label: 'Satin', key: 'satin', value: 'satin' },
          { label: 'Velvet', key: 'velvet', value: 'velvet' },
          { label: 'Cotton', key: 'cotton', value: 'cotton' },
          { label: 'Brocade', key: 'brocade', value: 'brocade' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
      },
      {
        label: 'Shoes',
        key: 'shoes',
        value: 'shoes',
        image: menShoes,

        type: [
          { label: 'Jutti', key: 'jutti', value: 'jutti' },
          { label: 'Mojhay', key: 'mojhay', value: 'mojhay' },
          { label: 'Sandals', key: 'sandals', value: 'sandals' },
          { label: 'Other', key: 'other', value: 'other' },
        ],
        size: [
          { label: '3', key: '3', value: '3' },
          { label: '3.5', key: '3.5', value: '3.5' },
          { label: '4', key: '4', value: '4' },
          { label: '4.5', key: '4.5', value: '4.5' },
          { label: '5', key: '5', value: '5' },
          { label: '5.5', key: '5.5', value: '5.5' },
          { label: '6', key: '6', value: '6' },
          { label: '6.5', key: '6.5', value: '6.5' },
          { label: '7', key: '7', value: '7' },
          { label: '7.5', key: '7.5', value: '7.5' },
          { label: '8', key: '8', value: '8' },
          { label: '8.5', key: '8.5', value: '8.5' },
          { label: '9', key: '9', value: '9' },
          { label: '9.5', key: '9.5', value: '9.5' },
          { label: '10', key: '10', value: '10' },
          { label: '10.5', key: '10.5', value: '10.5' },
          { label: '11', key: '11', value: '11' },
          { label: '11.5', key: '11.5', value: '11.5' },
          { label: '12', key: '12', value: '12' },
          { label: '12.5', key: '12.5', value: '12.5' },
          { label: '13', key: '13', value: '13' },
          { label: '13.5', key: '13.5', value: '13.5' },
          { label: '14', key: '14', value: '14' },
          { label: '14.5', key: '14.5', value: '14.5' },
          { label: '15', key: '15', value: '15' },
        ],
        colour: commonColor,
      },
      {
        label: 'Turbans',
        key: 'turbans',
        sLabel: 'Turban',
        value: 'turbans',
        colour: commonColor,
        image: menTurban,
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
      },
    ],
  },

  {
    label: 'Kids',
    key: 'kids',
    value: 'kids',
    image: kidClothing,
    subCategories: [
      {
        label: 'Clothing',
        key: 'clothing',
        value: 'clothing',
        image: kidClothing,
        type: [
          {
            label: 'Sarees',
            sLabel: 'Saree',
            key: 'sarees',
            showSleeves: true,
            value: 'sarees',
            image: [
              {
                image: 'W3',
                fields: W3FIELDS,
              },
            ],
          },
          {
            label: 'Lehengas',
            sLabel: 'Lehenga',
            showSleeves: true,
            key: 'lehengas',
            value: 'lehengas',
            image: [
              {
                image: 'W3',
                fields: W3FIELDS,
              },
              {
                image: 'W4',
                fields: W4FIELDS,
              },
            ],
          },
          {
            label: 'Dresses/Gown',
            sLabel: 'Dress/Gown',
            key: 'dresses',
            value: 'dresses',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
            ],
          },
          {
            label: 'Salwar Kameez Suits',
            sLabel: 'Salwar Kameez Suit',
            showSleeves: true,
            key: 'salwar-kameez',
            value: 'salwar-kameez',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Dhoti Salwar Suits',
            sLabel: 'Dhoti Salwar Suit',
            key: 'dhoti-salwar',
            value: 'dhoti-salwar',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Palazzo/Pant Suits',
            sLabel: 'Palazzo/Pant Suit',
            showSleeves: true,
            key: 'palazzo-suit',
            value: 'palazzo-suit',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Churidar/Pajami Suits',
            sLabel: 'Churidar/Pajami Suit',
            showSleeves: true,
            key: 'churidar-suit',
            value: 'churidar-suit',
            image: [
              {
                image: 'W1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Anarkali Suits',
            sLabel: 'Anarkali Suit',
            showSleeves: true,
            key: 'anarkali-suit',
            value: 'anarkali-suit',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Shararas',
            sLabel: 'Sharara',
            showSleeves: true,
            key: 'sharara',
            value: 'sharara',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Abaya Suits',
            sLabel: 'Abaya Suit',
            showSleeves: true,
            key: 'abaya',
            value: 'abaya',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
            ],
          },
          {
            label: 'Fusion Outfits',
            key: 'fusion',
            sLabel: 'Fusion Outfit',
            showSleeves: true,
            value: 'fusion',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
              {
                image: 'W2',
                fields: W2FIELDS,
              },
              {
                image: 'W3',
                fields: W3FIELDS,
              },
              {
                image: 'W4',
                fields: W4FIELDS,
              },
            ],
          },
          {
            label: 'Kurtis',
            sLabel: 'Kurti',
            showSleeves: true,
            key: 'kurti',
            value: 'kurti',
            image: [
              {
                image: 'K1',
                fields: W1FIELDS,
              },
            ],
          },

          {
            label: 'Sherwanis',
            sLabel: 'Sherwani',
            showSleeves: true,
            key: 'sherwani',
            value: 'sherwani',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Achkins',
            sLabel: 'Achkin',
            key: 'achkin',
            value: 'achkin',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Dhoti Kurtas',
            sLabel: 'Dhoti Kurta',
            showSleeves: true,
            key: 'dhoti-kurta',
            value: 'dhoti-kurta',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Kurta Pajamas',
            sLabel: 'Kurta Pajama',
            key: 'kurta-pajama',
            value: 'kurta-pajama',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
            ],
          },
          {
            label: 'Kurta Pajamas with Vest',
            sLabel: 'Kurta Pajama with Vest',
            key: 'kurta-pajama-2-pc',
            value: 'kurta-pajama-2-pc',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Jacket Suits 3 pc',
            sLabel: 'Jacket Suit 3 pc',
            key: 'jacket-3-pc',
            value: 'jacket-3-pc',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Nehru Suits',
            sLabel: 'Nehru Suit',
            key: 'nehru-jacket',
            value: 'nehru-jacket',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
          {
            label: 'Other',
            key: 'other',
            value: 'other',
            image: [
              {
                image: 'K2',
                fields: M1FIELDS,
              },
              {
                image: 'M2',
                fields: M2FIELDS,
              },
              {
                image: 'M3',
                fields: M3FIELDS,
              },
            ],
          },
        ],
        size: [
          { label: 'XS', key: 'xs', value: 'xs' },
          { label: 'S', key: 's', value: 's' },
          { label: 'M', key: 'm', value: 'm' },
          { label: 'L', key: 'l', value: 'l' },
          { label: 'XL', key: 'xl', value: 'xl' },
          { label: 'XXL', key: 'xxl', value: 'xxl' },
          { label: 'XXXL', key: 'xxxl', value: 'xxxl' },
        ],
        colour: commonColor,
        embroidery: [
          { label: 'Handwork', key: 'handwork', value: 'handwork' },
          { label: 'Mirror', key: 'mirror', value: 'mirror' },
          { label: 'Sequins', key: 'sequins', value: 'sequins' },
          { label: 'Thread', key: 'thread', value: 'thread' },
          { label: 'Print', key: 'print', value: 'print' },
          { label: 'Stone', key: 'stone', value: 'stone' },
          { label: 'Zari', key: 'zari', value: 'zari' },
          { label: 'Beadwork', key: 'beadwork', value: 'beadwork' },
        ],
        fabrics: [
          { label: 'Brocade', key: 'brocade', value: 'brocade' },
          { label: 'Chanderi', key: 'chanderi', value: 'chanderi' },
          { label: 'Chiffon', key: 'chiffon', value: 'chiffon' },
          { label: 'Crepe', key: 'crepe', value: 'crepe' },
          { label: 'Muslin', key: 'muslin', value: 'muslin' },
          { label: 'Organza', key: 'organza', value: 'organza' },
          { label: 'Pure Silk', key: 'pure-silk', value: 'pure-silk' },
          { label: 'Organza Silk', key: 'organza-silk', value: 'organza-silk' },
          { label: 'Velvet', key: 'velvet', value: 'velvet' },
          { label: 'Georgette', key: 'georgette', value: 'georgette' },
          { label: 'Net', key: 'net', value: 'net' },
          { label: 'Satin', key: 'satin', value: 'satin' },
          { label: 'Chinon', key: 'chinon', value: 'chinon' },
          { label: 'Rayon', key: 'rayon', value: 'rayon' },
          { label: 'Cotton', key: 'cotton', value: 'cotton' },
        ],

        size: [
          { label: '0-6mo', key: '0-6mo', value: '0-6mo' },
          { label: '6-12mo', key: '6-12mo', value: '6-12mo' },
          { label: '1-2', key: '1-2', value: '1-2' },
          { label: '3-4', key: '3-4', value: '3-4' },
          { label: '5-6', key: '5-6', value: '5-6' },
          { label: '7-8', key: '7-8', value: '7-8' },
          { label: '9-10', key: '9-10', value: '9-10' },
          { label: '11-12', key: '11-12', value: '11-12' },
          { label: '12+', key: '12+', value: '12+' },
        ],
        colour: commonColor,
      },
      {
        label: 'Shoes',
        key: 'shoes',
        value: 'shoes',
        image: kidShoes,

        size: [
          { label: '0', key: '0', value: '0' },
          { label: '0.5', key: '0.5', value: '0.5' },
          { label: '1', key: '1', value: '1' },
          { label: '1.5', key: '1.5', value: '1.5' },
          { label: '2', key: '2', value: '2' },
          { label: '2.5', key: '2.5', value: '2.5' },
          { label: '3', key: '3', value: '3' },
          { label: '3.5', key: '3.5', value: '3.5' },
          { label: '4', key: '4', value: '4' },
          { label: '4.5', key: '4.5', value: '4.5' },
          { label: '5', key: '5', value: '5' },
          { label: '5.5', key: '5.5', value: '5.5' },
          { label: '6', key: '6', value: '6' },
          { label: '6.5', key: '6.5', value: '6.5' },
          { label: '7', key: '7', value: '7' },
          { label: '7.5', key: '7.5', value: '7.5' },
          { label: '8', key: '8', value: '8' },
          { label: '8.5', key: '8.5', value: '8.5' },
          { label: '9', key: '9', value: '9' },
          { label: '9.5', key: '9.5', value: '9.5' },
          { label: '10', key: '10', value: '10' },
          { label: '10.5', key: '10.5', value: '10.5' },
          { label: '11', key: '11', value: '11' },
          { label: '11.5', key: '11.5', value: '11.5' },
          { label: '12', key: '12', value: '12' },
        ],
        colour: commonColor,
      },
    ],
  },
];

export const filters = categoryOptions?.map(category => {
  return {
    key: 'subCategory',
    value: category.key,
    scope: 'public',
    schemaType: 'enum',
    enumOptions: category.subCategories.map(subCategory => {
      return {
        option: subCategory.key,
        label: subCategory.label,
        type: subCategory?.type
          ? {
              key: 'type',
              scope: 'public',
              schemaType: 'enum',
              enumOptions: subCategory.type,
              filterConfig: {
                indexForSearch: true,
                filterType: 'SelectSingleFilter',
                label: 'Type',
                group: 'primary',
              },
            }
          : null,
        size: subCategory?.size
          ? {
              key: 'size',
              scope: 'public',
              schemaType: 'multi-enum',
              enumOptions: subCategory.size,
              filterConfig: {
                indexForSearch: true,
                filterType: 'SelectMultipleFilter',
                searchMode: 'has_any',

                label: 'Size',
                group: 'primary',
              },
            }
          : null,
        colour: subCategory?.colour
          ? {
              key: 'colour',
              scope: 'public',
              schemaType: 'multi-enum',
              enumOptions: subCategory.colour,
              filterConfig: {
                indexForSearch: true,
                filterType: 'SelectMultipleFilter',
                searchMode: 'has_any',
                label: 'Colour',
                group: 'primary',
              },
            }
          : null,
        fabrics: subCategory?.fabrics
          ? {
              key: 'fabrics',
              scope: 'public',
              schemaType: 'enum',
              enumOptions: subCategory.fabrics,
              filterConfig: {
                indexForSearch: true,
                filterType: 'SelectSingleFilter',
                label: 'Fabric',
                group: 'primary',
              },
            }
          : null,
        embroidery: subCategory?.embroidery
          ? {
              key: 'embroidery',
              scope: 'public',
              schemaType: 'enum',
              enumOptions: subCategory.embroidery,
              filterConfig: {
                indexForSearch: true,
                filterType: 'SelectSingleFilter',
                label: 'Embroidery',
                group: 'primary',
              },
            }
          : null,
      };
    }),
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Sub Category',
      group: 'primary',
    },
  };
});
export const listingFields = [
  {
    key: 'category',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [...categoryOptions],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Category',
      group: 'primary',
    },
  },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to select
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem' and 'multipleItems'.
 *                        Default: 'multipleItems'.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 */

export const listingTypes = [
  {
    listingType: 'daily-booking',
    label: 'Daily booking',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  // // Here are some examples for other listingTypes
  // // TODO: SearchPage does not work well if both booking and product selling are used at the same time
  // {
  //   listingType: 'nightly-booking',
  //   label: 'Nightly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'night',
  //   },
  // },
  // {
  //   listingType: 'hourly-booking',
  //   label: 'Hourly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'hour',
  //   },
  // },
  // {
  //   listingType: 'product-selling',
  //   label: 'Sell bicycles',
  //   transactionType: {
  //     process: 'default-purchase',
  //     alias: 'default-purchase/release-1',
  //     unitType: 'item',
  //   },
  //   stockType: 'multipleItems',
  //   defaultListingFields: {
  //     shipping: true,
  //     pickup: true,
  //     payoutDetails: true,
  //   },
  // },
  // {
  //   listingType: 'inquiry',
  //   label: 'Inquiry',
  //   transactionType: {
  //     process: 'default-inquiry',
  //     alias: 'default-inquiry/release-1',
  //     unitType: 'inquiry',
  //   },
  //   defaultListingFields: {
  //     price: false,
  //     location: true,
  //   },
  // },
];

export const countries = [
  {
    label: 'Afghanistan',
    key: 'AF',
    value: 'AF',
  },
  {
    label: 'Åland Islands',
    key: 'AX',
    value: 'AX',
  },
  {
    label: 'Albania',
    key: 'AL',
    value: 'AL',
  },
  {
    label: 'Algeria',
    key: 'DZ',
    value: 'DZ',
  },
  {
    label: 'American Samoa',
    key: 'AS',
    value: 'AS',
  },
  {
    label: 'AndorrA',
    key: 'AD',
    value: 'AD',
  },
  {
    label: 'Angola',
    key: 'AO',
    value: 'AO',
  },
  {
    label: 'Anguilla',
    key: 'AI',
    value: 'AI',
  },
  {
    label: 'Antarctica',
    key: 'AQ',
    value: 'AQ',
  },
  {
    label: 'Antigua and Barbuda',
    key: 'AG',
    value: 'AG',
  },
  {
    label: 'Argentina',
    key: 'AR',
    value: 'AR',
  },
  {
    label: 'Armenia',
    key: 'AM',
    value: 'AM',
  },
  {
    label: 'Aruba',
    key: 'AW',
    value: 'AW',
  },
  {
    label: 'Australia',
    key: 'AU',
    value: 'AU',
  },
  {
    label: 'Austria',
    key: 'AT',
    value: 'AT',
  },
  {
    label: 'Azerbaijan',
    key: 'AZ',
    value: 'AZ',
  },
  {
    label: 'Bahamas',
    key: 'BS',
    value: 'BS',
  },
  {
    label: 'Bahrain',
    key: 'BH',
    value: 'BH',
  },
  {
    label: 'Bangladesh',
    key: 'BD',
    value: 'BD',
  },
  {
    label: 'Barbados',
    key: 'BB',
    value: 'BB',
  },
  {
    label: 'Belarus',
    key: 'BY',
    value: 'BY',
  },
  {
    label: 'Belgium',
    key: 'BE',
    value: 'BE',
  },
  {
    label: 'Belize',
    key: 'BZ',
    value: 'BZ',
  },
  {
    label: 'Benin',
    key: 'BJ',
    value: 'BJ',
  },
  {
    label: 'Bermuda',
    key: 'BM',
    value: 'BM',
  },
  {
    label: 'Bhutan',
    key: 'BT',
    value: 'BT',
  },
  {
    label: 'Bolivia',
    key: 'BO',
    value: 'BO',
  },
  {
    label: 'Bosnia and Herzegovina',
    key: 'BA',
    value: 'BA',
  },
  {
    label: 'Botswana',
    key: 'BW',
    value: 'BW',
  },
  {
    label: 'Bouvet Island',
    key: 'BV',
    value: 'BV',
  },
  {
    label: 'Brazil',
    key: 'BR',
    value: 'BR',
  },
  {
    label: 'British Indian Ocean Territory',
    key: 'IO',
    value: 'IO',
  },
  {
    label: 'Brunei Darussalam',
    key: 'BN',
    value: 'BN',
  },
  {
    label: 'Bulgaria',
    key: 'BG',
    value: 'BG',
  },
  {
    label: 'Burkina Faso',
    key: 'BF',
    value: 'BF',
  },
  {
    label: 'Burundi',
    key: 'BI',
    value: 'BI',
  },
  {
    label: 'Cambodia',
    key: 'KH',
    value: 'KH',
  },
  {
    label: 'Cameroon',
    key: 'CM',
    value: 'CM',
  },
  {
    label: 'Canada',
    key: 'CA',
    value: 'CA',
  },
  {
    label: 'Cape Verde',
    key: 'CV',
    value: 'CV',
  },
  {
    label: 'Cayman Islands',
    key: 'KY',
    value: 'KY',
  },
  {
    label: 'Central African Republic',
    key: 'CF',
    value: 'CF',
  },
  {
    label: 'Chad',
    key: 'TD',
    value: 'TD',
  },
  {
    label: 'Chile',
    key: 'CL',
    value: 'CL',
  },
  {
    label: 'China',
    key: 'CN',
    value: 'CN',
  },
  {
    label: 'Christmas Island',
    key: 'CX',
    value: 'CX',
  },
  {
    label: 'Cocos (Keeling) Islands',
    key: 'CC',
    value: 'CC',
  },
  {
    label: 'Colombia',
    key: 'CO',
    value: 'CO',
  },
  {
    label: 'Comoros',
    key: 'KM',
    value: 'KM',
  },
  {
    label: 'Congo',
    key: 'CG',
    value: 'CG',
  },
  {
    label: 'Congo, The Democratic Republic of the',
    key: 'CD',
    value: 'CD',
  },
  {
    label: 'Cook Islands',
    key: 'CK',
    value: 'CK',
  },
  {
    label: 'Costa Rica',
    key: 'CR',
    value: 'CR',
  },
  {
    label: "Cote D'Ivoire",
    key: 'CI',
    value: 'CI',
  },
  {
    label: 'Croatia',
    key: 'HR',
    value: 'HR',
  },
  {
    label: 'Cuba',
    key: 'CU',
    value: 'CU',
  },
  {
    label: 'Cyprus',
    key: 'CY',
    value: 'CY',
  },
  {
    label: 'Czech Republic',
    key: 'CZ',
    value: 'CZ',
  },
  {
    label: 'Denmark',
    key: 'DK',
    value: 'DK',
  },
  {
    label: 'Djibouti',
    key: 'DJ',
    value: 'DJ',
  },
  {
    label: 'Dominica',
    key: 'DM',
    value: 'DM',
  },
  {
    label: 'Dominican Republic',
    key: 'DO',
    value: 'DO',
  },
  {
    label: 'Ecuador',
    key: 'EC',
    value: 'EC',
  },
  {
    label: 'Egypt',
    key: 'EG',
    value: 'EG',
  },
  {
    label: 'El Salvador',
    key: 'SV',
    value: 'SV',
  },
  {
    label: 'Equatorial Guinea',
    key: 'GQ',
    value: 'GQ',
  },
  {
    label: 'Eritrea',
    key: 'ER',
    value: 'ER',
  },
  {
    label: 'Estonia',
    key: 'EE',
    value: 'EE',
  },
  {
    label: 'Ethiopia',
    key: 'ET',
    value: 'ET',
  },
  {
    label: 'Falkland Islands (Malvinas)',
    key: 'FK',
    value: 'FK',
  },
  {
    label: 'Faroe Islands',
    key: 'FO',
    value: 'FO',
  },
  {
    label: 'Fiji',
    key: 'FJ',
    value: 'FJ',
  },
  {
    label: 'Finland',
    key: 'FI',
    value: 'FI',
  },
  {
    label: 'France',
    key: 'FR',
    value: 'FR',
  },
  {
    label: 'French Guiana',
    key: 'GF',
    value: 'GF',
  },
  {
    label: 'French Polynesia',
    key: 'PF',
    value: 'PF',
  },
  {
    label: 'French Southern Territories',
    key: 'TF',
    value: 'TF',
  },
  {
    label: 'Gabon',
    key: 'GA',
    value: 'GA',
  },
  {
    label: 'Gambia',
    key: 'GM',
    value: 'GM',
  },
  {
    label: 'Georgia',
    key: 'GE',
    value: 'GE',
  },
  {
    label: 'Germany',
    key: 'DE',
    value: 'DE',
  },
  {
    label: 'Ghana',
    key: 'GH',
    value: 'GH',
  },
  {
    label: 'Gibraltar',
    key: 'GI',
    value: 'GI',
  },
  {
    label: 'Greece',
    key: 'GR',
    value: 'GR',
  },
  {
    label: 'Greenland',
    key: 'GL',
    value: 'GL',
  },
  {
    label: 'Grenada',
    key: 'GD',
    value: 'GD',
  },
  {
    label: 'Guadeloupe',
    key: 'GP',
    value: 'GP',
  },
  {
    label: 'Guam',
    key: 'GU',
    value: 'GU',
  },
  {
    label: 'Guatemala',
    key: 'GT',
    value: 'GT',
  },
  {
    label: 'Guernsey',
    key: 'GG',
    value: 'GG',
  },
  {
    label: 'Guinea',
    key: 'GN',
    value: 'GN',
  },
  {
    label: 'Guinea-Bissau',
    key: 'GW',
    value: 'GW',
  },
  {
    label: 'Guyana',
    key: 'GY',
    value: 'GY',
  },
  {
    label: 'Haiti',
    key: 'HT',
    value: 'HT',
  },
  {
    label: 'Heard Island and Mcdonald Islands',
    key: 'HM',
    value: 'HM',
  },
  {
    label: 'Holy See (Vatican City State)',
    key: 'VA',
    value: 'VA',
  },
  {
    label: 'Honduras',
    key: 'HN',
    value: 'HN',
  },
  {
    label: 'Hong Kong',
    key: 'HK',
    value: 'HK',
  },
  {
    label: 'Hungary',
    key: 'HU',
    value: 'HU',
  },
  {
    label: 'Iceland',
    key: 'IS',
    value: 'IS',
  },
  {
    label: 'India',
    key: 'IN',
    value: 'IN',
  },
  {
    label: 'Indonesia',
    key: 'ID',
    value: 'ID',
  },
  {
    label: 'Iran, Islamic Republic Of',
    key: 'IR',
    value: 'IR',
  },
  {
    label: 'Iraq',
    key: 'IQ',
    value: 'IQ',
  },
  {
    label: 'Ireland',
    key: 'IE',
    value: 'IE',
  },
  {
    label: 'Isle of Man',
    key: 'IM',
    value: 'IM',
  },
  {
    label: 'Israel',
    key: 'IL',
    value: 'IL',
  },
  {
    label: 'Italy',
    key: 'IT',
    value: 'IT',
  },
  {
    label: 'Jamaica',
    key: 'JM',
    value: 'JM',
  },
  {
    label: 'Japan',
    key: 'JP',
    value: 'JP',
  },
  {
    label: 'Jersey',
    key: 'JE',
    value: 'JE',
  },
  {
    label: 'Jordan',
    key: 'JO',
    value: 'JO',
  },
  {
    label: 'Kazakhstan',
    key: 'KZ',
    value: 'KZ',
  },
  {
    label: 'Kenya',
    key: 'KE',
    value: 'KE',
  },
  {
    label: 'Kiribati',
    key: 'KI',
    value: 'KI',
  },
  {
    label: "Korea, Democratic People'S Republic of",
    key: 'KP',
    value: 'KP',
  },
  {
    label: 'Korea, Republic of',
    key: 'KR',
    value: 'KR',
  },
  {
    label: 'Kuwait',
    key: 'KW',
    value: 'KW',
  },
  {
    label: 'Kyrgyzstan',
    key: 'KG',
    value: 'KG',
  },
  {
    label: "Lao People'S Democratic Republic",
    key: 'LA',
    value: 'LA',
  },
  {
    label: 'Latvia',
    key: 'LV',
    value: 'LV',
  },
  {
    label: 'Lebanon',
    key: 'LB',
    value: 'LB',
  },
  {
    label: 'Lesotho',
    key: 'LS',
    value: 'LS',
  },
  {
    label: 'Liberia',
    key: 'LR',
    value: 'LR',
  },
  {
    label: 'Libyan Arab Jamahiriya',
    key: 'LY',
    value: 'LY',
  },
  {
    label: 'Liechtenstein',
    key: 'LI',
    value: 'LI',
  },
  {
    label: 'Lithuania',
    key: 'LT',
    value: 'LT',
  },
  {
    label: 'Luxembourg',
    key: 'LU',
    value: 'LU',
  },
  {
    label: 'Macao',
    key: 'MO',
    value: 'MO',
  },
  {
    label: 'Macedonia, The Former Yugoslav Republic of',
    key: 'MK',
    value: 'MK',
  },
  {
    label: 'Madagascar',
    key: 'MG',
    value: 'MG',
  },
  {
    label: 'Malawi',
    key: 'MW',
    value: 'MW',
  },
  {
    label: 'Malaysia',
    key: 'MY',
    value: 'MY',
  },
  {
    label: 'Maldives',
    key: 'MV',
    value: 'MV',
  },
  {
    label: 'Mali',
    key: 'ML',
    value: 'ML',
  },
  {
    label: 'Malta',
    key: 'MT',
    value: 'MT',
  },
  {
    label: 'Marshall Islands',
    key: 'MH',
    value: 'MH',
  },
  {
    label: 'Martinique',
    key: 'MQ',
    value: 'MQ',
  },
  {
    label: 'Mauritania',
    key: 'MR',
    value: 'MR',
  },
  {
    label: 'Mauritius',
    key: 'MU',
    value: 'MU',
  },
  {
    label: 'Mayotte',
    key: 'YT',
    value: 'YT',
  },
  {
    label: 'Mexico',
    key: 'MX',
    value: 'MX',
  },
  {
    label: 'Micronesia, Federated States of',
    key: 'FM',
    value: 'FM',
  },
  {
    label: 'Moldova, Republic of',
    key: 'MD',
    value: 'MD',
  },
  {
    label: 'Monaco',
    key: 'MC',
    value: 'MC',
  },
  {
    label: 'Mongolia',
    key: 'MN',
    value: 'MN',
  },
  {
    label: 'Montserrat',
    key: 'MS',
    value: 'MS',
  },
  {
    label: 'Morocco',
    key: 'MA',
    value: 'MA',
  },
  {
    label: 'Mozambique',
    key: 'MZ',
    value: 'MZ',
  },
  {
    label: 'Myanmar',
    key: 'MM',
    value: 'MM',
  },
  {
    label: 'Namibia',
    key: 'NA',
    value: 'NA',
  },
  {
    label: 'Nauru',
    key: 'NR',
    value: 'NR',
  },
  {
    label: 'Nepal',
    key: 'NP',
    value: 'NP',
  },
  {
    label: 'Netherlands',
    key: 'NL',
    value: 'NL',
  },
  {
    label: 'Netherlands Antilles',
    key: 'AN',
    value: 'AN',
  },
  {
    label: 'New Caledonia',
    key: 'NC',
    value: 'NC',
  },
  {
    label: 'New Zealand',
    key: 'NZ',
    value: 'NZ',
  },
  {
    label: 'Nicaragua',
    key: 'NI',
    value: 'NI',
  },
  {
    label: 'Niger',
    key: 'NE',
    value: 'NE',
  },
  {
    label: 'Nigeria',
    key: 'NG',
    value: 'NG',
  },
  {
    label: 'Niue',
    key: 'NU',
    value: 'NU',
  },
  {
    label: 'Norfolk Island',
    key: 'NF',
    value: 'NF',
  },
  {
    label: 'Northern Mariana Islands',
    key: 'MP',
    value: 'MP',
  },
  {
    label: 'Norway',
    key: 'NO',
    value: 'NO',
  },
  {
    label: 'Oman',
    key: 'OM',
    value: 'OM',
  },
  {
    label: 'Pakistan',
    key: 'PK',
    value: 'PK',
  },
  {
    label: 'Palau',
    key: 'PW',
    value: 'PW',
  },
  {
    label: 'Palestinian Territory, Occupied',
    key: 'PS',
    value: 'PS',
  },
  {
    label: 'Panama',
    key: 'PA',
    value: 'PA',
  },
  {
    label: 'Papua New Guinea',
    key: 'PG',
    value: 'PG',
  },
  {
    label: 'Paraguay',
    key: 'PY',
    value: 'PY',
  },
  {
    label: 'Peru',
    key: 'PE',
    value: 'PE',
  },
  {
    label: 'Philippines',
    key: 'PH',
    value: 'PH',
  },
  {
    label: 'Pitcairn',
    key: 'PN',
    value: 'PN',
  },
  {
    label: 'Poland',
    key: 'PL',
    value: 'PL',
  },
  {
    label: 'Portugal',
    key: 'PT',
    value: 'PT',
  },
  {
    label: 'Puerto Rico',
    key: 'PR',
    value: 'PR',
  },
  {
    label: 'Qatar',
    key: 'QA',
    value: 'QA',
  },
  {
    label: 'Reunion',
    key: 'RE',
    value: 'RE',
  },
  {
    label: 'Romania',
    key: 'RO',
    value: 'RO',
  },
  {
    label: 'Russian Federation',
    key: 'RU',
    value: 'RU',
  },
  {
    label: 'RWANDA',
    key: 'RW',
    value: 'RW',
  },
  {
    label: 'Saint Helena',
    key: 'SH',
    value: 'SH',
  },
  {
    label: 'Saint Kitts and Nevis',
    key: 'KN',
    value: 'KN',
  },
  {
    label: 'Saint Lucia',
    key: 'LC',
    value: 'LC',
  },
  {
    label: 'Saint Pierre and Miquelon',
    key: 'PM',
    value: 'PM',
  },
  {
    label: 'Saint Vincent and the Grenadines',
    key: 'VC',
    value: 'VC',
  },
  {
    label: 'Samoa',
    key: 'WS',
    value: 'WS',
  },
  {
    label: 'San Marino',
    key: 'SM',
    value: 'SM',
  },
  {
    label: 'Sao Tome and Principe',
    key: 'ST',
    value: 'ST',
  },
  {
    label: 'Saudi Arabia',
    key: 'SA',
    value: 'SA',
  },
  {
    label: 'Senegal',
    key: 'SN',
    value: 'SN',
  },
  {
    label: 'Serbia and Montenegro',
    key: 'RS',
    value: 'RS',
  },
  {
    label: 'Seychelles',
    key: 'SC',
    value: 'SC',
  },
  {
    label: 'Sierra Leone',
    key: 'SL',
    value: 'SL',
  },
  {
    label: 'Singapore',
    key: 'SG',
    value: 'SG',
  },
  {
    label: 'Slovakia',
    key: 'SK',
    value: 'SK',
  },
  {
    label: 'Slovenia',
    key: 'SI',
    value: 'SI',
  },
  {
    label: 'Solomon Islands',
    key: 'SB',
    value: 'SB',
  },
  {
    label: 'Somalia',
    key: 'SO',
    value: 'SO',
  },
  {
    label: 'South Africa',
    key: 'ZA',
    value: 'ZA',
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    key: 'GS',
    value: 'GS',
  },
  {
    label: 'Spain',
    key: 'ES',
    value: 'ES',
  },
  {
    label: 'Sri Lanka',
    key: 'LK',
    value: 'LK',
  },
  {
    label: 'Sudan',
    key: 'SD',
    value: 'SD',
  },
  {
    label: 'Suriname',
    key: 'SR',
    value: 'SR',
  },
  {
    label: 'Svalbard and Jan Mayen',
    key: 'SJ',
    value: 'SJ',
  },
  {
    label: 'Swaziland',
    key: 'SZ',
    value: 'SZ',
  },
  {
    label: 'Sweden',
    key: 'SE',
    value: 'SE',
  },
  {
    label: 'Switzerland',
    key: 'CH',
    value: 'CH',
  },
  {
    label: 'Syrian Arab Republic',
    key: 'SY',
    value: 'SY',
  },
  {
    label: 'Taiwan, Province of China',
    key: 'TW',
    value: 'TW',
  },
  {
    label: 'Tajikistan',
    key: 'TJ',
    value: 'TJ',
  },
  {
    label: 'Tanzania, United Republic of',
    key: 'TZ',
    value: 'TZ',
  },
  {
    label: 'Thailand',
    key: 'TH',
    value: 'TH',
  },
  {
    label: 'Timor-Leste',
    key: 'TL',
    value: 'TL',
  },
  {
    label: 'Togo',
    key: 'TG',
    value: 'TG',
  },
  {
    label: 'Tokelau',
    key: 'TK',
    value: 'TK',
  },
  {
    label: 'Tonga',
    key: 'TO',
    value: 'TO',
  },
  {
    label: 'Trinidad and Tobago',
    key: 'TT',
    value: 'TT',
  },
  {
    label: 'Tunisia',
    key: 'TN',
    value: 'TN',
  },
  {
    label: 'Turkey',
    key: 'TR',
    value: 'TR',
  },
  {
    label: 'Turkmenistan',
    key: 'TM',
    value: 'TM',
  },
  {
    label: 'Turks and Caicos Islands',
    key: 'TC',
    value: 'TC',
  },
  {
    label: 'Tuvalu',
    key: 'TV',
    value: 'TV',
  },
  {
    label: 'Uganda',
    key: 'UG',
    value: 'UG',
  },
  {
    label: 'Ukraine',
    key: 'UA',
    value: 'UA',
  },
  {
    label: 'United Arab Emirates',
    key: 'AE',
    value: 'AE',
  },
  {
    label: 'United Kingdom',
    key: 'GB',
    value: 'GB',
  },
  {
    label: 'United States',
    key: 'US',
    value: 'US',
  },
  {
    label: 'United States Minor Outlying Islands',
    key: 'UM',
    value: 'UM',
  },
  {
    label: 'Uruguay',
    key: 'UY',
    value: 'UY',
  },
  {
    label: 'Uzbekistan',
    key: 'UZ',
    value: 'UZ',
  },
  {
    label: 'Vanuatu',
    key: 'VU',
    value: 'VU',
  },
  {
    label: 'Venezuela',
    key: 'VE',
    value: 'VE',
  },
  {
    label: 'Viet Nam',
    key: 'VN',
    value: 'VN',
  },
  {
    label: 'Virgin Islands, British',
    key: 'VG',
    value: 'VG',
  },
  {
    label: 'Virgin Islands, U.S.',
    key: 'VI',
    value: 'VI',
  },
  {
    label: 'Wallis and Futuna',
    key: 'WF',
    value: 'WF',
  },
  {
    label: 'Western Sahara',
    key: 'EH',
    value: 'EH',
  },
  {
    label: 'Yemen',
    key: 'YE',
    value: 'YE',
  },
  {
    label: 'Zambia',
    key: 'ZM',
    value: 'ZM',
  },
  {
    label: 'Zimbabwe',
    key: 'ZW',
    value: 'ZW',
  },
];
export const configlisting = {
  // This flag defines if unit type translation is used:
  // e.g. "100 € per night" vs "100 €"
  showUnitTypeTranslations: false,

  // These aspectWidth and aspectHeight values are used to calculate aspect ratio.
  aspectWidth: 400,
  aspectHeight: 400,
  // Listings have custom image variants, which are named here.
  variantPrefix: 'default',
};

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = false;
